import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-[var(--radius-md)] border border-[var(--color-mist-300)] bg-[var(--color-white)] px-4 py-3 text-base text-[var(--color-charcoal)] shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--color-charcoal)] placeholder:text-[var(--color-stone-500)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-burgundy-500)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
